// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3c2TE","noInteraction":"EventWrapper_noInteraction__Ibd06"};